import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";
import { StatusBadge } from "./StatusTimeline";
import { api, errMsg, fmtDate } from "../lib/api";

export const TicketThread = ({ ticket, onUpdate, extra }) => {
  const [body, setBody] = useState("");
  const send = async () => {
    if (!body.trim()) return;
    try {
      const { data } = await api.post(`/me/tickets/${ticket.id}/messages`, { body });
      setBody("");
      onUpdate(data);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="rounded-lg border bg-white" data-testid={`ticket-thread-${ticket.id}`}>
      <div className="flex flex-wrap items-center gap-2 border-b p-4">
        <p className="flex-1 font-semibold">{ticket.subject}</p>
        <span className="text-xs uppercase tracking-wide text-muted-foreground">{ticket.category}</span>
        <StatusBadge status={ticket.status} />
        {extra}
      </div>
      <div className="space-y-3 p-4">
        {ticket.messages.map((m, i) => (
          <div key={i} className={`max-w-[85%] rounded-md p-3 text-sm ${m.author_role === "admin" ? "ml-auto bg-ink text-white" : "bg-muted"}`}>
            <p className="mb-1 text-[11px] opacity-70">{m.author_role === "admin" ? "HostAfricair Support" : m.author_name} · {fmtDate(m.at)}</p>
            <p className="whitespace-pre-wrap">{m.body}</p>
          </div>
        ))}
      </div>
      {ticket.status !== "closed" && (
        <div className="flex gap-2 border-t p-3">
          <Textarea rows={2} value={body} onChange={(e) => setBody(e.target.value)} placeholder="Write a reply…" data-testid="ticket-reply-input" />
          <Button onClick={send} data-testid="ticket-reply-send-btn"><Send className="h-4 w-4" /></Button>
        </div>
      )}
    </div>
  );
};
